// src/app/guards/login-auth.guard.ts

import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { LoginAuthService } from '../services/login-auth.service';

@Injectable({
  providedIn: 'root'
})
export class LoginAuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private loginAuthService: LoginAuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const isAuthenticated = this.loginAuthService.isAuthenticated();

    if (isAuthenticated) {
      // Usuario autenticado, permitir acceso a las rutas protegidas
      return true;
    } else {
      // Usuario no autenticado, redirigir al login
      console.log('Acceso denegado. Redirigiendo al login...');
      return this.router.createUrlTree(['/login']);
    }
  }
}
